import React, { useState } from 'react'

import { SHAREABLE_LINKS_TABLE_PAGE_SIZE } from '../../../pages/emailAndCalendarIntegration/components/ShareableLinks/constants'
import DataTable from '../../datatable/DataTable'
import SkeletonTable from '../../skeleton/SkeletonTable'
import TablePagination from '../TablePagination'
import EditReferralLinkModal from './components/EditReferralLinkCodeModal'
import ReferralLinksTableRow from './components/ReferralLinksTableRow'
import { useIsViewingAsFromCompany } from './hooks/useIsViewingAsFromCompany'
import { ReferralLinkTableRow } from './types'

interface Props {
  referralLinks: ReferralLinkTableRow[]
  totalReferralLinks: number
  isLoading?: boolean
  activePage: number
  onPageChange: (page: number) => void
}

const ReferralLinksTable: React.FC<Props> = ({
  referralLinks,
  totalReferralLinks,
  isLoading,
  activePage,
  onPageChange,
}) => {
  const isViewingAsFromCompany = useIsViewingAsFromCompany()

  const [linkBeingEdited, setLinkBeingEdited] =
    useState<ReferralLinkTableRow | null>(null)

  if (isLoading) {
    return (
      <SkeletonTable rows={SHAREABLE_LINKS_TABLE_PAGE_SIZE + 1} columns={2} />
    )
  }

  const hasNylasLink = referralLinks.some((link) => link.hasNylasScheduler)

  return (
    <>
      <DataTable
        tableProps={{ className: 'table-fixed', style: { width: '700px' } }}
      >
        <colgroup>
          {/* Introduce to / Partner company */}
          <col style={{ width: '250px' }} />

          {/* Referrals booked */}
          <col style={{ width: '130px' }} />

          {/* Link code */}
          <col style={{ width: '300px' }} />

          {/* Link actions */}
          <col style={{ width: '150px' }} />
        </colgroup>

        <thead>
          <tr>
            <th>
              {isViewingAsFromCompany ? 'Introduce to' : 'Partner company'}
            </th>
            <th>Referrals booked</th>
            <th>{hasNylasLink ? 'Link code' : 'Link'}</th>
            <th>Link actions</th>
          </tr>
        </thead>

        <tbody>
          {referralLinks.map((link) => (
            <ReferralLinksTableRow
              referralLink={link}
              key={link['@id']}
              onEditClick={(referralLink) => setLinkBeingEdited(referralLink)}
            />
          ))}
        </tbody>
      </DataTable>

      {totalReferralLinks > SHAREABLE_LINKS_TABLE_PAGE_SIZE && (
        <div className="mt-3">
          <TablePagination
            activePage={activePage}
            totalItemsCount={totalReferralLinks}
            numItemsPerPage={SHAREABLE_LINKS_TABLE_PAGE_SIZE}
            onChange={onPageChange}
          />
        </div>
      )}

      {linkBeingEdited && (
        <EditReferralLinkModal
          referralLink={linkBeingEdited}
          onHide={() => setLinkBeingEdited(null)}
        />
      )}
    </>
  )
}

export default ReferralLinksTable
